/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { Vertical } from "./social-share";

export function VerticalGrey(props) {
  return <Vertical grey {...props} />;
}
